import { ButtonGroup } from 'element-ui'

const YButtonGroup = ButtonGroup
YButtonGroup.$depends = [ButtonGroup]
YButtonGroup.$name = 'y-button-group'
YButtonGroup._name = 'YButtonGroup 按钮组'

export default YButtonGroup
